import React from 'react';

/**
 * The shopper's "automatic try-ons in every KuzFit shop" choice. Off by default; each shop still
 * decides whether it applies there.
 */
const AutoTryOnSwitch = ({ checked, disabled, onChange, id = 'kuzfit-auto-try-on' }) => (
  <div className="custom-control custom-switch text-left">
    <input
      type="checkbox"
      className="custom-control-input"
      id={id}
      checked={!!checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <label className="custom-control-label" htmlFor={id}>
      Automatic try-ons in every KuzFit shop
    </label>
    <div className="small text-muted">
      Shops that allow it show products on you as you browse, without pressing "Try it on".
    </div>
  </div>
);

export default AutoTryOnSwitch;
